import omit from 'lodash/omit';

import { Project, ProjectModel, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 *  Migration to remove the model text from each project model
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v22 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v22Projects(prevState.projects);
  }

  return nextState;
};

const v22Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    const modelsById = { ...project.modelsById };
    const updatedModelsById = Object.values(modelsById).reduce<
      Record<string, ProjectModel>
    >((acc, model) => {
      const updatedModel = omit(model, 'text');
      acc[updatedModel.id] = updatedModel;
      return acc;
    }, {});

    projectsById[projectId] = {
      ...project,
      modelsById: updatedModelsById,
    };
  });

  return { ...prevProjectsState, projectsById };
};
